import React from 'react'
import muiThemeable from 'material-ui/styles/muiThemeable'
import glamorous from 'glamorous'

const Item = muiThemeable()(
  glamorous.a(
    ({
      muiTheme: {
        palette: {
          accent2Color,
        },
      },
    }) => ({
      padding: '11px 15px',
      display: 'inline-block',
      borderBottomWidth: 0,
      borderStyle: 'solid',
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      fontSize: 20,
    }),
    ({
      isActive,
      muiTheme: {
        palette: {
          accent2Color,
          borderColor,
        },
      },
    }) => ({
      backgroundColor: isActive ? '#ffffff' : accent2Color,
      marginBottom: isActive ? -1 : 0,
      borderColor: isActive ? borderColor : 'transparent',
      borderLeftWidth: isActive ? 1 : 0,
      borderTopWidth: isActive ? 1 : 0,
      borderRightWidth: isActive ? 1 : 0,
    })
  )
)

const TextStyle = muiThemeable()(
  glamorous.span(
    ({
      muiTheme: {
        palette: {
          accent2Color,
        },
      },
    }) => ({
    }),
    ({
      isActive,
      muiTheme: {
        palette: {
          primary1Color,
          accent1Color,
        },
      },
    }) => ({
      color: isActive ? accent1Color : primary1Color,
      fontSize: 15,
    })
  )
)

const TabElement3 = ({
  onTouchTap,
  isActive,
  tabLabel,
}) => {
  return (
    <Item
      isActive={isActive}
      onClick={onTouchTap}
    >
      <TextStyle as="span" isActive={isActive} >
        {tabLabel}
      </TextStyle>
    </Item>
  )
}

TabElement3.propTypes = {}
TabElement3.defaultProps = {}

export default TabElement3



// WEBPACK FOOTER //
// ./src/components/Tabs/ElementTabs/ElementTabC.js